//Announcement bar above menu slider

document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.cc-announcement-slider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.cc-announcement-slider__slide');
  const prevArrow = slider.querySelector('.cc-announcement-slider__nav--prev');
  const nextArrow = slider.querySelector('.cc-announcement-slider__nav--next');
  const autoRotate = slider.getAttribute('data-auto-rotate') === 'true';
  const sliderSpeed = parseInt(slider.getAttribute('data-slider-speed'), 10) * 1000 || 5000;

  let currentIndex = 0;
  let autoRotateInterval;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.style.opacity = '0';
      slide.style.display = 'none';
      slide.classList.remove('visible');
    });

    slides[index].style.display = 'block';
    setTimeout(() => {
      slides[index].style.opacity = '1';
      slides[index].classList.add('visible');
    }, 10); // Slight delay to allow opacity transition
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  }

  function prevSlide() {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    showSlide(currentIndex);
  }

  function startAutoRotate() {
    stopAutoRotate(); // Clear any existing interval to avoid multiple intervals running.
    if (autoRotate && slides.length > 1) {
      autoRotateInterval = setInterval(nextSlide, sliderSpeed);
    }
  }

  function stopAutoRotate() {
    clearInterval(autoRotateInterval);
  }

  if (nextArrow) {
    nextArrow.addEventListener('click', () => {
      nextSlide();
      startAutoRotate(); // Restart the timer after manual interaction
    });
  }

  if (prevArrow) {
    prevArrow.addEventListener('click', () => {
      prevSlide();
      startAutoRotate(); // Restart the timer after manual interaction
    });
  }

  // Start the slider initially
  showSlide(currentIndex);
  startAutoRotate();
});

// Back button with scroll position memory
(function() {
  var SCROLL_STORAGE_KEY = 'betseys_scroll_positions';

  function getScrollPositions() {
    try {
      var data = sessionStorage.getItem(SCROLL_STORAGE_KEY);
      return data ? JSON.parse(data) : {};
    } catch (e) {
      return {};
    }
  }

  function saveScrollPosition() {
    try {
      var positions = getScrollPositions();
      positions[window.location.href] = window.scrollY || window.pageYOffset;
      sessionStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify(positions));
    } catch (e) {}
  }

  function restoreScrollPosition() {
    try {
      var positions = getScrollPositions();
      var savedPosition = positions[window.location.href];
      if (typeof savedPosition === 'number') {
        setTimeout(function() {
          window.scrollTo(0, savedPosition);
        }, 100);
      }
    } catch (e) {}
  }

  function isSameOrigin(url) {
    try {
      var link = document.createElement('a');
      link.href = url;
      return link.hostname === window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  // Save scroll position before leaving the page
  window.addEventListener('beforeunload', saveScrollPosition);

  // Save scroll position on same-origin link clicks
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (link && link.href && isSameOrigin(link.href)) {
      saveScrollPosition();
    }
  });

  // Restore scroll position on page load
  document.addEventListener('DOMContentLoaded', function() {
    restoreScrollPosition();

    // Back button click handler
    var prevArrow = document.querySelector('.cc-announcement-slider__nav--prev');
    if (prevArrow) {
      prevArrow.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var referrer = document.referrer;
        if (referrer && isSameOrigin(referrer)) {
          window.history.back();
        } else {
          window.location.href = '/collections/all';
        }
      });
    }
  });
})();
